import { LitElement, html } from 'lit';
import fsTypography from '@cof/fs-typography-core/lib/typography.lit.min.js';
import { TagKey } from '@cof/tag-catalog-fs-vehicle-and-loan-mfe';
import { nothing } from 'lit-html';
import { style } from './iconic-choose-vehicle.style.js';
import { DebugService } from '../../../shared/services/debug.service.js';
import { VehicleService } from '../../../services/vehicle.service.js';
import { REFI_VEHICLE_LOAN_CONST } from '../../../shared/constants/app.constants.js';
import { tags } from '../../../shared/constants/tags.js';
import { stratum } from '../../../../constants/stratum.js';
import '../iconic-vehicle-lookup/iconic-vehicle-lookup.component.js';
import '../iconic-vehicle-card/iconic-vehicle-card.component.js';
import { ApplicationService } from '../../../services/application.service.js';
import '../../iconic-container/iconic-container.component.js';
import { VehicleAndLoanService } from '../../../services/vehicle-and-loan.service.js';

class RefiIconicChooseVehicle extends LitElement {
  constructor() {
    super();
    this.debug = new DebugService('RefiIconicChooseVehicle');
    this.vehicleList = [];
    this.showVehicleLookup = true;
    this.marketingOffer = ApplicationService.MarketingOffer;
    this.isFromMatch = VehicleAndLoanService.showMatches;
  }

  connectedCallback() {
    super.connectedCallback();
    this.vehicleList = VehicleService.vehicleList;
    if (!ApplicationService.isInAppDeclineDelayOn) {
      stratum.publishTag(TagKey.PAGE_VIEW_COAF_REFI_PREQUALIFY_VEHICLE_LOAN);
    }

    this.sendHostAppHeaderUpdates();
    window.scrollTo(0, 0);
  }

  static properties = {
    showVehicleLookup: { type: Boolean },
    usedLicensePlateSearch: { type: Boolean },
  };

  static styles = [style, fsTypography];

  selectVehicle(e) {
    // match lookup type with vehicle service
    this.usedLicensePlateSearch =
      VehicleService.lookupType ===
      REFI_VEHICLE_LOAN_CONST.VEHICLE_LOOKUP_TYPE.SSN
        ? undefined
        : VehicleService.lookupType ===
          REFI_VEHICLE_LOAN_CONST.VEHICLE_LOOKUP_TYPE.LICENSE_PLATE;

    const selectedVehicle = e?.detail?.vehicle;
    this.debug.log('vehicle log event captured', selectedVehicle);
    REFI_VEHICLE_LOAN_CONST.TRACK_EVENT(tags.vehicle.refileads);
    REFI_VEHICLE_LOAN_CONST.TRACK_EVENT(
      tags.vehicle.selected(
        selectedVehicle.year,
        selectedVehicle.make,
        selectedVehicle.model
      )
    );
    if (this.usedLicensePlateSearch === undefined) {
      stratum.publishTag(
        ApplicationService.isInAppDeclineDelayOn
          ? TagKey.VEHICLE_FOUND_VEHICLE_SELECTED_SSN
          : TagKey.VEHICLE_FOUND_VEHICLE_SELECTED_LN,
        {
          replacements: {
            value: `${selectedVehicle.year} ${selectedVehicle.make} ${selectedVehicle.model}`,
          },
        }
      );
    } else {
      const lpKey = ApplicationService.isInAppDeclineDelayOn
        ? TagKey.VEHICLE_FOUND_VEHICLE_SELECTED_LICENSE_PLATE_2
        : TagKey.VEHICLE_FOUND_VEHICLE_SELECTED_LICENSE_PLATE;
      const vinKey = ApplicationService.isInAppDeclineDelayOn
        ? TagKey.VEHICLE_FOUND_VEHICLE_SELECTED_VIN_2
        : TagKey.VEHICLE_FOUND_VEHICLE_SELECTED_VIN;
      stratum.publishTag(this.usedLicensePlateSearch ? lpKey : vinKey, {
        replacements: {
          value: `${selectedVehicle.year} ${selectedVehicle.make} ${selectedVehicle.model}`,
        },
      });
    }
    VehicleService.selectedVehicle = selectedVehicle;
    this.dispatchEvent(new CustomEvent('next-step'));
  }

  renderVehicleCards() {
    let vehicleLookupHTML = html``;
    if (!this.showVehicleLookup && this.vehicleList.length > 0) {
      stratum.publishTag(
        ApplicationService.isInAppDeclineDelayOn
          ? TagKey.PAGE_VIEW_COAF_REFI_PREQUALIFY_VEHICLE_LOAN_VEHICLE_2
          : TagKey.PAGE_VIEW_COAF_REFI_PREQUALIFY_VEHICLE_LOAN_VEHICLE
      );

      const vehicleCardMapper = (vehicle, i) => html` <div>
        <refi-iconic-vehicle-card
          .vehicle="${vehicle}"
          vehicleIndex="${i}"
          .showLicensePlate="${false}"
          @select-vehicle="${this.selectVehicle}"
          showButton
          hide-ineligibility="${ApplicationService.isInAppDeclineDelayOn
            ? ''
            : nothing}"
        ></refi-iconic-vehicle-card>
      </div>`;
      vehicleLookupHTML = html`
        <div class="grid">${this.vehicleList.map(vehicleCardMapper)}</div>
        <div class="return-cta">
          <fs-button
            class="return-cta-button"
            @click="${this.goToVehicleLookup}"
            tabindex="0"
            data-track="change vehicle"
            ghost
            compact
            data-e2e-ref="return-cta"
            >I want to refinance a different car</fs-button
          >
        </div>
      `;
    }
    return vehicleLookupHTML;
  }

  goToVehicleLookup() {
    REFI_VEHICLE_LOAN_CONST.TRACK_EVENT(tags.vehicle.changeVehicle);
    stratum.publishTag(
      ApplicationService.isInAppDeclineDelayOn
        ? TagKey.VEHICLE_FOUND_CHOOSE_A_DIFFERENT_VEHICLE_2
        : TagKey.VEHICLE_FOUND_CHOOSE_A_DIFFERENT_VEHICLE
    );
    this.showVehicleLookup = true;
    this.isFromMatch = false;
    setTimeout(() => {
      window.scroll({ top: -1, left: 0 });
    }, 1);
  }

  hideVehicleLookup() {
    if (this.isFromMatch) {
      window.history.back();
    }
    this.isFromMatch = false;
    this.showVehicleLookup = false;
    setTimeout(() => {
      window.scroll({ top: -1, left: 0 });
    }, 1);
  }

  foundVehicles() {
    this.debug.log('found vehicles');
    this.vehicleList = VehicleService.vehicleList;
    this.usedLicensePlateSearch =
      VehicleService.lookupType ===
      REFI_VEHICLE_LOAN_CONST.VEHICLE_LOOKUP_TYPE.LICENSE_PLATE;
    let isValid = false;
    this.vehicleList.forEach((vehicle) => {
      if (VehicleService.isEligible(vehicle)) {
        isValid = true;
      }
    });
    if (isValid || ApplicationService.isInAppDeclineDelayOn) {
      this.showVehicleLookup = false;
      window.scrollTo(0, 0);
    } else {
      this.dispatchEvent(
        new CustomEvent('go-to-exit', { bubbles: true, composed: true })
      );
    }
  }

  headerText() {
    if (this.showVehicleLookup || this.vehicleList.length === 0) {
      return 'Help us find your car';
    }
    if (ApplicationService.isInAppDeclineDelayOn) {
      return this.vehicleList.length > 1
        ? 'Which car do you want to refinance?'
        : 'Is this the car you want to refinance?';
    }
    return 'Confirm the car and loan you want to refinance';
  }

  render() {
    this.debug.log('rendered');
    return html`
      <refi-track-pageview pagename="vehicle"></refi-track-pageview>
      <refi-iconic-container
        .headerText="${this.headerText()}"
        .marketingOffer="${this.marketingOffer}"
        data-e2e-ref="choose-vehicle-container"
      >
        ${this.renderVehicleCards()}
        ${this.showVehicleLookup || this.vehicleList.length === 0
          ? html`<refi-iconic-vehicle-lookup
              @found-vehicles=${this.foundVehicles}
            ></refi-iconic-vehicle-lookup>`
          : ''}
        ${this.showVehicleLookup && this.vehicleList.length !== 0
          ? html`<div class="return-cta">
              <fs-button
                class="return-cta-button"
                @click="${this.hideVehicleLookup}"
                tabindex="0"
                data-track=""
                ghost
                compact
                >Go back to car options</fs-button
              >
            </div>`
          : ''}
      </refi-iconic-container>
    `;
  }

  sendHostAppHeaderUpdates() {
    this.dispatchEvent(
      new CustomEvent('show-progress-bar', {
        detail: {
          displayBar: true,
        },
        composed: true,
        bubbles: true,
      })
    );
    this.dispatchEvent(
      new CustomEvent('header-bottom-slot-color-change', {
        bubbles: true,
        composed: true,
        detail: { colored: false },
      })
    );
  }
}

customElements.define('refi-iconic-choose-vehicle', RefiIconicChooseVehicle);
